import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UnifiedAuthContext.jsx';
import { authAPI } from '../../utils/api.js';
import { isPortalFlowId, watchPortalRequest } from '../../utils/portalLogin.js';

export default function PortalLoginAcknowledgement() {
    const route = useLocation();
    const navigate = useNavigate();
    const { technician, loading, error, urlParams } = useAuth();

    useEffect(() => {
        const params = new URLSearchParams(route.search);
        const flowId = params.get('portalFlow');
        if (
            window.self === window.top
            || route.pathname !== '/dashboard'
            || loading
            || error
            || !technician
            || !isPortalFlowId(flowId)
            || params.get('location') !== urlParams.location
            || params.get('user') !== urlParams.user
        ) return;

        return watchPortalRequest({
            request: signal => authAPI.acknowledgePortalLogin(flowId, {
                signal,
                cache: 'no-store'
            }),
            onResult: (result, signal) => {
                if (signal.aborted) return true;
                if (!result.success) return true;
                params.delete('portalFlow');
                navigate({ pathname: route.pathname, search: `?${params}`, hash: route.hash }, { replace: true });
                return true;
            },
            // Network failures, rate limits, and server failures can recover
            // after a background tab wakes. Invalid or unauthorized flows cannot.
            onError: error => {
                const status = Number(error?.status);
                return status >= 400 && status < 500 && status !== 429;
            }
        });
    }, [error, loading, navigate, route.hash, route.pathname, route.search, technician, urlParams.location, urlParams.user]);

    return null;
}
